<template>
  <div id="raft-user-lookup-wrapper">
    <raft-autocomplete
      :key="fieldConfig.field_name"
      field-class="entity-reference-field"
      ref="autocomplete"
      :id="fieldConfig.field_name"
      :name="fieldConfig.field_name"
      :value="selectedUser"
      :label="fieldConfig.label"
      element-id="raft-user-autocomplete"
      :placeholder="getPlaceholder()"
      :source="debounceUserLookup"
      :results-display="formattedResultsDisplay"
      results-property="value"
      input-class="form-control"
      @selected="updateSelected"
      :disabled="disabled"
      :show-label="showLabel"
      :allow-delete="allowDelete"
    >
      <template #action>
        <a
          v-if="allowDelete"
          class="remove-icon-wrapper"
          @click="
            $emit('removeField', value !== null ? value.id : null, fieldIndex)
          "
        >
          <span class="visuallyhidden">Remove</span>
          <img class="remove-icon" alt="Remove" :src="removeSrc" />
        </a>
      </template>
    </raft-autocomplete>
  </div>
</template>

<script>
import { jsonClient } from "@/lib/raftApi";
import debounce from "lodash/debounce";
import RaftAutocomplete from "./RaftAutocomplete.vue";
import remove from "../../images/remove.svg";

export default {
  name: "UserLookup",
  components: {
    RaftAutocomplete,
  },
  data() {
    return {
      selectedUser: {},
      removeSrc: remove,
      debounceUserLookup: debounce(this.userLookup, 300, {
        leading: false,
      }),
    };
  },
  props: {
    fieldConfig: { type: Object, required: true },
    value: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
    loseNameContains: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    allowDelete: { type: Boolean, default: false },
    fieldIndex: { type: Number, default: 1 },
  },
  methods: {
    getPlaceholder: function () {
      let placeholder = this.fieldConfig.form_display?.settings?.placeholder;
      if (placeholder === "") {
        placeholder = "Look up the involved person";
      }
      return placeholder;
    },
    userLookup: async function (input) {
      const options = {
        path: "user/user",
        queries: {
          "filter[status]": 1,
          "filter[name][condition][path]": "field_prof_display_name",
          "filter[name][condition][value]": input,
          "filter[name][condition][operator]": "CONTAINS",
        },
      };
      if (this.loseNameContains) {
        options.queries = {};
        input.split(" ").forEach((name, index) => {
          options.queries["filter[name-" + index + "][path]"] =
            "field_prof_display_name";
          options.queries["filter[name-" + index + "][value]"] = name;
          options.queries["filter[name-" + index + "][operator]"] = "CONTAINS";
        });
      }

      const response = await jsonClient.get(options).catch((error) => {
        console.error("Failed to find any users."); // eslint-disable-line no-console
        console.error(error); // eslint-disable-line no-console
      });

      const results = response?.deserialized;
      if (results) {
        this.$refs.autocomplete.setResults([]);
        this.$refs.autocomplete.setResults(results);
      }
    },
    updateSelected: function (value) {
      this.$emit("userLookupSelection", value, this.fieldIndex);
    },
    formattedResultsDisplay(result) {
      return `${result.field_prof_display_name} (${result.drupal_internal__uid})`;
    },
  },
  mounted() {
    if (this.value) {
      this.selectedUser = this.value;
      this.$refs.autocomplete.setResults([this.value]);
      this.$refs.autocomplete.select(this.value);
    }
  },
};
</script>

<style scoped></style>
